import 'core-js/stable';
import 'regenerator-runtime/runtime';

import { createApp } from "vue";

import App from "./App.vue";
import router from "./router"; // اگر داری از Vue Router استفاده می‌کنی
import "./assets/fonts.css";

import "./assets/main.css";

import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import fa from "element-plus/es/locale/lang/fa";
import { createPinia } from "pinia";
import piniaPluginPersistedstate from "pinia-plugin-persistedstate";
import VueToast from "vue-toast-notification";
import "vue-toast-notification/dist/theme-sugar.css";

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

const app = createApp(App);
app.use(VueToast, {
  position: "top-left",
  duration: 5000, // زمان نمایش
});
app.use(pinia);
app.use(ElementPlus, { locale: fa });
app.use(router); // اگر نداریش حذفش کن
app.mount("#app");
